/**
 * The four pinyin tone marks (ˉ ˊ ˇ ˋ) the light galaxy sprinkles through its background in place
 * of stars (star-sized, slightly tilted and twinkling), as round-capped polylines in a unit box
 * (`y` pointing down) with their stroke width. The atlas strokes them into sprite cells; the static
 * fallback draws the same lines in SVG.
 */
export const WELCOME_GALAXY_TONE_MARKS: readonly (readonly (readonly [number, number])[])[] = [
  // ˉ first tone: level.
  [
    [0.2, 0.5],
    [0.8, 0.5],
  ],
  // ˊ second tone: rising.
  [
    [0.32, 0.74],
    [0.68, 0.26],
  ],
  // ˇ third tone: dipping, then rising.
  [
    [0.2, 0.32],
    [0.5, 0.68],
    [0.8, 0.32],
  ],
  // ˋ fourth tone: falling.
  [
    [0.32, 0.26],
    [0.68, 0.74],
  ],
];

/** The marks' stroke width, in the unit box. */
export const WELCOME_GALAXY_TONE_MARK_STROKE = 0.16;

/** A tone mark as an SVG path in a `size` × `size` box. */
export function welcomeGalaxyToneMarkPath(tone: number, size: number): string {
  const points = WELCOME_GALAXY_TONE_MARKS[tone] ?? [];
  return points
    .map(([x, y], index) => `${index === 0 ? "M" : "L"}${x * size} ${y * size}`)
    .join(" ");
}
